import { render, staticRenderFns } from "./6introduce.vue?vue&type=template&id=473a9bf2&scoped=true&"
import script from "./6introduce.vue?vue&type=script&lang=js&"
export * from "./6introduce.vue?vue&type=script&lang=js&"
import style0 from "./6introduce.vue?vue&type=style&index=0&id=473a9bf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473a9bf2",
  null
  
)

export default component.exports